import { WithAccountId, CommanderThunkAction } from '@mews-commander/types';
import { AccountType } from '@mews-commander/data-access';
import { navigateInModal } from '../app/actions/common';
import { getMergeCompaniesUrl, getMergeCustomersUrl } from './selectors';

export interface MergeAccountsProps extends WithAccountId {
    otherAccountId: string;
    accountType: AccountType;
}

export const mergeAccounts =
    ({ accountId, otherAccountId, accountType }: MergeAccountsProps): CommanderThunkAction =>
    (dispatch, getState, { resolveRoute, featureFlagService }) => {
        const url =
            accountType === AccountType.Customer
                ? getMergeCustomersUrl(getState(), { id: accountId, otherAccountId, resolveRoute, featureFlagService })
                : getMergeCompaniesUrl(getState(), { id: accountId, otherAccountId, resolveRoute, featureFlagService });
        return dispatch(navigateInModal(url));
    };
